import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useContext } from "react";
import { DashboardContext } from "../../../../DashboardContext/DashboardContextProvider";

const uploadFiles = async (data) => {
  const { clientId, projectId, idProp, files, userId } = data;

  const uploadPromises = files.map((file) => {
    return axios.postForm(
      `/api/upload-form-file/${clientId}/${projectId}/${idProp}/`,
      {
        file: file,
        fileName: file.name,
        userId: userId,
      },
      {
        withCredentials: true,
      },
    );
  });

  return Promise.all(uploadPromises);
};

export const useUploadFiles = (setIsUploading, setState) => {
  const { queryClient } = useContext(DashboardContext);
  return useMutation({
    mutationFn: uploadFiles,
    onError: (err) => {
      console.error("UPLOAD FILES ERROR: ", err);
    },
    onSuccess: (data) => {
      console.log("UPLOAD FILES SUCCESS: ", data);
    },
    onSettled: (data) => {
      if (data) {
        queryClient.invalidateQueries({
          queryKey: ["currentProject", data.clientId, data.projectId],
        });
      }
      setIsUploading(false);
    },
  });
};

const deleteFile = async (data) => {
  const { projectId, idProp, uploadId } = data;
  console.log("DELETE FILE DATA: ", data);
  try {
    const res = await axios.delete(
      `/api/delete-form-file/${projectId}/${idProp}/${uploadId}/`,
      { withCredentials: true },
    );

    return res.data;
  } catch (err) {
    console.error(err);
  }
};

export const useDeleteFile = (
  clientId,
  projectId,
  idProp,
  state,
  setState,
  enqueueSnackbar,
) => {
  const { queryClient } = useContext(DashboardContext);
  return useMutation({
    mutationFn: (data) => deleteFile({ ...data, idProp, projectId }),
    onMutate: (data) => {
      const oldData = state[idProp];

      console.log("OLD DATA: ", oldData);
      console.log("DATA: ", data);

      setState((prevState) => ({
        ...prevState,
        [idProp]: {
          ...oldData,
          files: oldData.files.filter((file) => file.id !== data.uploadId),
        },
      }));

      return { oldData };
    },
    onError: (err, context) => {
      console.error("DELETE FILES ERROR: ", err);
      enqueueSnackbar("Error deleting file", {
        variant: "error",
        autoHideDuration: 3000,
      });

      if (context?.oldData) {
        setState((prevState) => ({
          ...prevState,
          [idProp]: context.oldData,
        }));
      }
    },
    onSuccess: (data) => {
      console.log("DELETE FILE SUCCESS: ", data);
      if (data) {
        // Update the state with the returned files
        setState((prevState) => ({
          ...prevState,
          [idProp]: {
            ...prevState[idProp],
            files: data.files, // Update with the new list of files
          },
        }));
        enqueueSnackbar("File deleted successfully", {
          variant: "success",
          autoHideDuration: 2500,
        });
      }
    },
    onSettled: (data) => {
      queryClient.invalidateQueries({
        queryKey: ["currentProject", clientId, projectId],
      });
    },
  });
};
